import { IconButton } from 'components/elements';
import { getSeverityColor } from 'lib/styles';
import { styled } from 'styles';
import { StyledNotificationBorderProps, StyledNotificationIconProps } from './types';

export const NotificationAction = styled.div`
  align-items: center;
  display: flex;
`;

export const NotificationBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin-right: ${({ theme }) => theme.spacing.absolute.small};
`;

export const NotificationBorder = styled.div<StyledNotificationBorderProps>`
  background-color: ${({ $severity, theme }) => getSeverityColor(theme, $severity)};
  border-radius: 0.3em;
  opacity: 0.8;
  width: 0.3em;
`;

export const NotificationButton = styled(IconButton)`
  background-color: transparent;
  border-radius: 50%;
  font-size: 0.8em;
  height: unset;
  margin-left: 0 ${({ theme }) => theme.spacing.absolute.small};
  opacity: 0.5;
  padding: 0;
  width: unset;

  &:hover:not(:disabled) {
    background-color: transparent;
    opacity: 1;
  }
`;

export const NotificationCaption = styled.div`
  color: ${({ theme }) => theme.notification.caption.color};
  font-weight: 500;
`;

export const NotificationContent = styled.div`
  align-items: stretch;
  display: flex;
  flex: 1;
  padding: 0 0 0 ${({ theme }) => theme.spacing.absolute.smaller};
  width: 100%;
  z-index: 2;
`;

export const NotificationIcon = styled.div<StyledNotificationIconProps>`
  align-items: center;
  color: ${({ $severity, theme }) => getSeverityColor(theme, $severity)};
  display: flex;
  font-size: 1.6em;
  margin-right: ${({ theme }) => theme.spacing.absolute.smaller};
  opacity: 0.8;
`;

export const NotificationMessage = styled.div`
  color: ${({ theme }) => theme.notification.color};
  font-size: 0.9em;
  margin-top: ${({ theme }) => theme.spacing.absolute.tiny};
`;

export const StyledNotification = styled.div`
  align-items: stretch;
  border-radius: ${({ theme }) => theme.radius.medium};
  background-color: ${({ theme }) => theme.notification.background};
  box-shadow: ${({ theme }) => theme.shadow.large};
  cursor: default;
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.absolute.smaller};
  min-height: 4.5em;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.absolute.small};
  position: relative;
  transition: box-shadow ${({ theme }) => theme.transition.medium} ease-in-out,
    opacity ${({ theme }) => theme.transition.medium} ease-in-out;

  &.enter {
    opacity: 0;
  }

  &.enter-active {
    opacity: 1;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
  }

  @media (max-width: 576px) {
    margin-bottom: ${({ theme }) => theme.spacing.absolute.tiny};
  }
`;

NotificationAction.displayName = 'NotificationAction';
NotificationBody.displayName = 'NotificationBody';
NotificationButton.displayName = 'NotificationButton';
NotificationCaption.displayName = 'NotificationCaption';
NotificationContent.displayName = 'NotificationContent';
NotificationIcon.displayName = 'NotificationIcon';
NotificationMessage.displayName = 'NotificationMessage';
StyledNotification.displayName = 'Notification.Styled';
